export const ROUTING = {
    HOME: '/',
    ABOUT_US: '/about-us',
    PROFILE: '/profile',
    AUTHORIZATION_CALLBACK: '/authorization-callback/:driver',
    RESERVATIONS: '/reservations',
    REQUESTS: '/requests/:page?',
    REQUESTS_MAIN: '/requests',
    REPORTS: '/reports',
    ALERTS: '/alerts',
    RESERVATION_PAGE: '/reservations/view/:id',
    REQUEST_PAGE: '/requests/view/:id',
    CONTENT_HUB_LINK: 'https://ujv.frontkb.com/en',
    WHITE_LABEL_LINK: 'https://www.ultimatejetvacations.com/profile/',
    SIGN_UP: '/sign-up',
    RESET_PASSWORD: '/reset-password',
    FORGOT_PASSWORD: '/forgot-password',
    UNAUTHORIZE: '/app/401',
};
